/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlusIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PlusIcon({
  children,
  viewPath = "/DesignSystem/Svgs/PlusIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  fill = "none",
  stroke = "#2E2E2E"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="PlusIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-Z26TrPw': alignSelf,'--mt-2-Z26TrPw': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z26TrPw': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z26TrPw': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z26TrPw': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z26TrPw': opacity,'--w-7-Z26TrPw': typeof width === 'number' ? `${width}px` : width,'--h-8-Z26TrPw': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="PlusIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={4}
 strokeMiterlimit={10}
 d="M16 3.3v25.4M28.7 16H3.3"
 style={{'--f-9-Z26TrPw': fill,'--s-10-Z26TrPw': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}